export function prefetchRoute (router, target) {
    const route = router.resolve(target)
    const loaders = route.matched.flatMap(record =>
        Object.values(record.components ?? {}).filter(component => typeof component === 'function')
    )

    return Promise.allSettled(loaders.map(loader => loader()))
}